import Firebase from '../../lib/Firebase';
import Firestore from '../../lib/Firestore';

export default {
  all () {
    return Firebase.firestore().collection('cities')
      .get()
      .then((docs) => {
        return Firestore.getCollectionData(docs);
      });
  },

  add (city) {
    const cityObj = {
      name: city,
      manager: {},
      configs: {},
      zipcodes: []
    };

    return Firebase.firestore().collection('cities')
      .add(cityObj);
  }
};



// WEBPACK FOOTER //
// ./src/pages/cities/service.js